import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import Service from "../component/images/Service";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import { Image, Card, Row, Col, Radio, Checkbox, ConfigProvider } from "antd";
import CustomLoader from "../component/menu/CustomLoader";
import { useNavigate } from "react-router-dom";
import EditIcon from "../component/images/Edit";
import SingleCheckBoxItem from "../component/profile/SingleCheckBokItem";
import CheckAllComponent from "../component/profile/CheckAllComponent";
import {
  branchDefaultValues,
  formatLoyaltyProgramSettingsReq,
  getLoyalProgramFormatedData,
  hasInvalidValuesInCurrentSlab,
  updateProfileSettings,
  validateSettingsData,
} from "../services/profile-service";
import CheckboxGroupComponent from "../component/profile/CheckboxGroupComponent";
import { serverImgFullPath } from "../utils/Common";
import RadioButtonGroupComponent from "../component/profile/RadioButtonGroupComponent";
import LoyaltyProgramSpendBaseSlabs from "../component/profile/LoyaltyProgramSpendBaseSlabs";
import CustomInputNumber from "../component/CustomInputNumber";
import { TAKEOUT_TYPES } from "../constant/constants";
import PosBanksModal from "../component/modals/PosBanksModal";

function Profile() {
  const navigate = useNavigate();
  const {
    user,
    restaurantId,
    restaurantSlug,
    setNetworkCall,
    showNotification,
    setIsPayLater,
    setVatServiceCharge,
    setLoyaltyProgramSettings,
  } = useUserStore();

  const [branch, setBranch] = useState(branchDefaultValues);

  const [paymentOptions, setPaymentOptions] = useState({
    customersPaymentOptions: ["COUNTER", "ONLINE"],
    selectedOptionsCustomers: [],
    isAllCheckedCustomers: false,
    adminsPaymentOptions: ["CASH", "POS", "BKASH", "NAGAD"],
    selectedOptionsAdmins: [],
    isAllCheckedAdmins: false,
    payLaterEnabled: false,
  });

  const [inventoryType, setInventoryType] = useState("ITEM");
  const [loyaltySettings, setLoyaltySettings] = useState({ ...branchDefaultValues.loyaltyProgramSettings });
  const [loyaltySlabs, setLoyaltySlabs] = useState([branchDefaultValues.loyaltyProgramSettings.spentBasedSystem.slabs]);
  const [takeoutTypeSettings, setTakeoutTypesSettings] = useState({
    takeoutTypes: TAKEOUT_TYPES,
    selectedTakeoutTypes: [],
    isAllChecked: false,
  });
  const [posBankList, setPosBankList] = useState([]);
  const [posBanks, setPosBanks] = useState([]);
  const [selectedPosBanks, setSelectedPosBanks] = useState([]);
  const [openPosBankModal, setOpenPosBankModal] = useState(false);
  const [execBranchDetails, setExecBranchDetails] = useState(0);

  /**
   * Get branch details
   */
  async function getBranchDetails(id) {
    if (id === null) return;
    const token = user.token.token;
    try {
      const res = await ApiService.GET_BRANCH_WITH_ID(id, token);
      if (res.code !== 200) {
        showNotification(res.message);
        return;
      }

      const { payload } = res;
      return payload;
    } catch (err) {
      showNotification(err.response.data.message || "Something went wrong");
      return;
    }
  }

  // restaurant id
  useEffect(() => {
    if (Boolean(restaurantId)) {
      getBranchDetails(restaurantId).then((data) => {
        setBranch({
          ...data,
          vat: parseFloat(data?.vat),
          serviceCharge: parseFloat(data?.serviceCharge),
          bannerImages: data?.images ? [...data.images] : "",
        });
        setVatServiceCharge({ restaurantVat: data?.vat || "0", restaurantServiceCharge: data?.serviceCharge || "0" });

        setPaymentOptions((prev) => ({
          ...prev,
          selectedOptionsCustomers: data.customersPaymentOptions,
          isAllCheckedCustomers: prev.customersPaymentOptions.length === data.customersPaymentOptions.length,
          selectedOptionsAdmins: data.adminsPaymentOptions,
          isAllCheckedAdmins: prev.adminsPaymentOptions.length === data.adminsPaymentOptions.length,
          payLaterEnabled: data.acceptPayAfterEat,
        }));
        setInventoryType(data.inventoryType);
        setIsPayLater(data.acceptPayAfterEat);
        setLoyaltyProgramSettings(data.loyaltyProgramSettings);
        const tmpLoyalty = getLoyalProgramFormatedData(data);
        setLoyaltySettings(tmpLoyalty);
        setLoyaltySlabs(tmpLoyalty.spentBasedSystem.slabs);
        setTakeoutTypesSettings((prev) => ({
          ...prev,
          selectedTakeoutTypes: data.takeoutTypes,
          isAllChecked: TAKEOUT_TYPES.length === data.takeoutTypes.length,
        }));

        const tempPosBanks = data.posBanks;
        const tempPosBankList = data.posBankList;
        const newList = syncPosBankListWithSelectedBanks(tempPosBankList, tempPosBanks);

        setPosBankList([...newList]);
        setPosBanks(tempPosBanks);
        setSelectedPosBanks(tempPosBanks);
      });
    }
  }, [restaurantId, execBranchDetails]);

  function syncPosBankListWithSelectedBanks(bankList, selectedBankList) {
    if (!Array.isArray(selectedBankList) || selectedBankList.length === 0) {
      return bankList.map((pb) => ({ ...pb, isActive: false }));
    }

    return bankList.map((pb) => {
      const isSelected = selectedBankList.some((el) => el.posBankId === pb.posBankId);
      return {
        ...pb,
        isActive: isSelected,
      };
    });
  }

  const updateSettings = async () => {
    const errors = validateSettingsData(paymentOptions, loyaltySettings, loyaltySlabs);

    if (errors.length > 0) {
      showNotification(errors[0]);
      return;
    }

    let params = {
      restaurantId,
      acceptPayAfterEat: paymentOptions.payLaterEnabled,
      kitchenSlipOnly: branch.kitchenSlipOnly,
      paymentOptions,
      inventoryType,
      tableManagement: branch.tableManagement,
      takeoutTypes: takeoutTypeSettings.selectedTakeoutTypes,
      loyaltyProgramSettings: formatLoyaltyProgramSettingsReq(loyaltySettings, loyaltySlabs),
      posBanks: selectedPosBanks,
    };

    setNetworkCall(true);
    const result = await updateProfileSettings(params, user.token.token);
    setNetworkCall(false);

    if (result.success) {
      showNotification(result.msg, false);
      setIsPayLater(params.acceptPayAfterEat);
      setSelectedPosBanks([]);
      setExecBranchDetails((prev) => prev + 1);
    } else {
      showNotification(result.msg);
    }
  };

  function onHandleEdit() {
    if (branch.parentRestaurantId !== "") {
      const queryParams = new URLSearchParams({ isAdmin: "true" });
      navigate(`/restaurants/${branch.parentRestaurantId}/branch/${restaurantId}/edit?${queryParams.toString()}`);
    }
  }

  const onChangeSingleCheckbox = (purpose, e) => {
    if (purpose === "PAY_LATER") {
      setPaymentOptions((prev) => ({
        ...prev,
        payLaterEnabled: e.target.checked,
      }));
    } else if (purpose === "KITCHEN_SLIP") {
      setBranch((prevState) => ({
        ...prevState,
        kitchenSlipOnly: e.target.checked,
      }));
    }
  };

  const handleCheckAll = (purpose, e) => {
    const isAllChecked = e.target.checked;

    if (purpose === "TAKEOUT_TYPES") {
      setTakeoutTypesSettings((prev) => ({
        ...prev,
        selectedTakeoutTypes: isAllChecked ? prev.takeoutTypes : [],
        isAllChecked,
      }));

      return;
    }

    if (purpose === "LOYALTY_POINT_BASED") {
      setLoyaltySettings((prev) => ({
        ...prev,
        pointBasedSystem: {
          ...prev.pointBasedSystem,
          isActive: isAllChecked,
        },
      }));

      return;
    }

    if (purpose === "LOYALTY_SPEND_BASED") {
      setLoyaltySettings((prev) => ({
        ...prev,
        spentBasedSystem: {
          ...prev.spentBasedSystem,
          isActive: isAllChecked,
        },
      }));

      return;
    }

    if (purpose === "CUSTOMERS_PAYMENT") {
      setPaymentOptions((prev) => ({
        ...prev,
        selectedOptionsCustomers: isAllChecked ? prev.customersPaymentOptions : [],
        isAllCheckedCustomers: isAllChecked,
      }));
    } else {
      setPaymentOptions((prev) => ({
        ...prev,
        selectedOptionsAdmins: isAllChecked ? prev.adminsPaymentOptions : [],
        isAllCheckedAdmins: isAllChecked,
      }));
    }
  };

  const handleCheckboxGroup = (purpose, selectedOptions) => {
    if (purpose === "TAKEOUT_TYPES") {
      setTakeoutTypesSettings((prev) => ({
        ...prev,
        selectedTakeoutTypes: selectedOptions,
        isAllChecked: prev.takeoutTypes.length === selectedOptions.length,
      }));
      return;
    }

    if (purpose === "CUSTOMERS_PAYMENT") {
      setPaymentOptions((prev) => ({
        ...prev,
        selectedOptionsCustomers: selectedOptions,
        isAllCheckedCustomers: prev.customersPaymentOptions.length === selectedOptions.length,
      }));
    } else {
      setPaymentOptions((prev) => ({
        ...prev,
        selectedOptionsAdmins: selectedOptions,
        isAllCheckedAdmins: prev.adminsPaymentOptions.length === selectedOptions.length,
      }));
    }
  };

  const updateLoyaltySettings = (nameValObj) => {
    const [index, field] = nameValObj.name.split("_");

    if (field === "pointPerHundredTKSpent") {
      setLoyaltySettings((prev) => ({
        ...prev,
        pointBasedSystem: {
          ...prev.pointBasedSystem,
          pointPerHundredTKSpent: nameValObj.value,
        },
      }));
    }

    if (field === "minRedeemPoint") {
      setLoyaltySettings((prev) => ({
        ...prev,
        pointBasedSystem: {
          ...prev.pointBasedSystem,
          minRedeemPoint: nameValObj.value,
        },
      }));
    }
  };

  const onChangeRadioButtonHandler = (purpose, val) => {
    if (purpose === "LOYALTY_PROGRAM") {
      setLoyaltySettings((prev) => ({
        ...prev,
        isActive: val, // or 'Off'
      }));
    }
  };

  const updateLoyaltySlabs = (uuid, field, value) => {
    setLoyaltySlabs((prev) => prev.map((s) => (s.uuid === uuid ? { ...s, [field]: value } : s)));
  };

  function onHandleAddRemoveLoyalSlabs(uuid = "") {
    if (uuid) {
      setLoyaltySlabs((prev) => prev.filter((item) => item.uuid !== uuid));
      return;
    }

    const slabsLen = loyaltySlabs.length;
    const errMsg = hasInvalidValuesInCurrentSlab(loyaltySlabs[slabsLen - 1]);

    if (errMsg) {
      showNotification(errMsg);
      return;
    }

    if (slabsLen === 9) {
      showNotification("You are allowed to add upto 9 slots.");
      return;
    }

    setLoyaltySlabs((prev) => [
      ...prev,
      {
        uuid: crypto.randomUUID(),
        minAmount: "",
        discountPercent: "",
      },
    ]);
  }

  const serviceTypes = [];

  function preparePosBankCheckboxOptions(posBanks = []) {
    if (posBanks.length === 0) return;
    const options = posBanks.map((pb) => ({
      label: pb.displayName,
      value: pb.posBankId,
    }));

    return options;
  }

  function updatePosBankList(pbid, field, value) {
    setPosBankList((prev) => prev.map((item) => (item.posBankId === pbid ? { ...item, [field]: value } : item)));
  }

  function onHandlePosBankDoneBtn() {
    const tempSelectedPosBanks = [];

    for (const el of posBankList) {
      if (el.isActive) {
        if (el.displayName === "") {
          showNotification("Display name can not empty!");
          return;
        }
        tempSelectedPosBanks.push({
          posBankId: el.posBankId,
          displayName: el.displayName,
        });
      }
    }

    setSelectedPosBanks(tempSelectedPosBanks);
    setOpenPosBankModal(false);
  }

  function onHandlePosBankCancelBtn() {
    // remove the selected values
    //setSelectedPosBanks(posBanks);
    //setPosBankList(syncPosBankListWithSelectedBanks(posBankList, posBanks));
    setOpenPosBankModal(false);
  }

  function onHandlePosBankCheckbox(selectedValues) {
    setSelectedPosBanks((prev) => prev.filter((item) => selectedValues.includes(item.posBankId)));
    setPosBankList((prev) =>
      prev.map((item) => ({
        ...item,
        isActive: selectedValues.includes(item.posBankId),
      }))
    );
  }

  return (
    <div className="flex flex-col">
      <CustomLoader />
      <Header title={branch.restaurantName || "Restaurant Profile"} />
      <div className="flex flex-col p-[24px] w-full mt-[80px] font-uregular">
        <div className="flex flex-col bg-white rounded">
          <div className="flex items-start justify-between rounded p-[24px]">
            <div className="flex items-start">
              <Image
                width={120}
                height={120}
                src={serverImgFullPath(branch.logo)}
                fallback={"/images/tabletap.svg"}
                className="rounded-full flex-shrink-0"
              />

              <div className="flex flex-col font-uregular ml-[24px] justify-between flex-1 min-w-0">
                <div className="text-xl font-ubold break-all">{branch.restaurantName}</div>

                <a href={`tel:${user?.countryCode}${user?.phone}`}>
                  <div className="text-md font-regular cursor-pointer truncate">
                    {`+${user?.countryCode}${user?.phone}`}
                  </div>
                </a>

                <div
                  className="text-md font-regular break-all whitespace-normal"
                  style={{ wordBreak: "break-all", overflowWrap: "anywhere" }}
                >
                  {branch.address}
                </div>

                <div className="flex flex-wrap gap-6">
                  <div>BIN: {branch.bin || "_____"}</div>
                  <div>Vat Reg. No.: {branch.vatRegNo || "_____"}</div>
                  <div>Mushak: {branch.mushak || "_____"}</div>
                </div>
                <div className="flex gap-4 mt-2">
                  <div className="flex border p-2">
                    <div className="w-[140px]">Vat included?: </div>
                    <div>{branch.isVatIncluded ? 'Yes' : 'No'}</div>
                  </div>
                  <div className="flex border p-2">
                    <div className="w-[210px]">Service Charge Included?:</div>
                    <div>{branch.isServiceChargeIncluded ? 'Yes' : 'No'}</div>
                  </div>
                  <div className="flex border p-2">
                    <div className="w-[250px]">Supplementary Duty Included?:</div>
                    <div>{branch.isSupplementaryDutyIncluded ? 'Yes' : 'No'}</div>
                  </div>
                </div>
                <div className="flex gap-4 mt-2">
                  <div className="flex border p-2">
                    <div className="w-[134px]">Vat: </div>
                    <div>{branch.vat}%</div>
                  </div>
                  <div className="flex border p-2">
                    <div className="w-[210px]">Service Charge:</div>
                    <div>{branch.serviceCharge}%</div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <button onClick={onHandleEdit}>
                <EditIcon
                  attributes={{
                    color: "#572D86",
                    size: 32,
                    classes: "cursor-pointer",
                  }}
                />
              </button>
            </div>
          </div>

          <div className="flex flex-row bg-purple font-uregular p-[16px] items-center justify-between">
            <div className="flex flex-row">
              <Service color="#FFFFFF" classes="w-[24px] h-[24px] ml-[8px] mr-[24px]" />
              {serviceTypes.map((type, index) => (
                <React.Fragment key={type}>
                  {index > 0 && <div className="text-xl text-white mx-[24px]">|</div>}
                  <div className="text-xl text-white">{type}</div>
                </React.Fragment>
              ))}
            </div>
            <div className="text-white font-semibold">Restaurant Code: {restaurantSlug}</div>
            <a
              href={`https://maps.google.com/?q=${branch.latitude},${branch.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="bg-yellow py-[8px] cursor-pointer px-[16px] font-ubold rounded-[24px]">Google Map</div>
            </a>
          </div>

          {/** start of card */}
          <div className="">
            <Card styles={{ body: { padding: "0px" } }} style={{ borderRadius: "0px" }}>
              <div className="bg-gray-100 p-10">
                <Row gutter={16}>
                  <Col span={8}>
                    <Card variant="borderless">
                      <SingleCheckBoxItem
                        purpose={"PAY_LATER"}
                        isChecked={paymentOptions.payLaterEnabled}
                        mainLabel={"Allow Pay After Eat:"}
                        checkboxLabel={"Pay Later"}
                        onChangeHandler={onChangeSingleCheckbox}
                      />
                      <div className="p-3"></div>
                      <SingleCheckBoxItem
                        purpose={"KITCHEN_SLIP"}
                        isChecked={branch.kitchenSlipOnly}
                        mainLabel={"Kitchen Display Settings"}
                        checkboxLabel={"Kitchen Slip Only"}
                        onChangeHandler={onChangeSingleCheckbox}
                      />
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      title="Customer Payment Method"
                      variant="borderless"
                      extra={
                        <CheckAllComponent
                          purpose={"CUSTOMERS_PAYMENT"}
                          mainLabel=""
                          checkboxLabel={"Check All"}
                          isChecked={paymentOptions.isAllCheckedCustomers}
                          onChangeHandler={handleCheckAll}
                        />
                      }
                    >
                      <div className="flex flex-row w-full gap-14">
                        <CheckboxGroupComponent
                          purpose={"CUSTOMERS_PAYMENT"}
                          options={paymentOptions.customersPaymentOptions}
                          selectedOptions={paymentOptions.selectedOptionsCustomers}
                          onChangeHandler={handleCheckboxGroup}
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      title="Restaurant Payment Method"
                      variant="borderless"
                      extra={
                        <CheckAllComponent
                          purpose={"ADMINS_PAYMENT"}
                          mainLabel=""
                          checkboxLabel={"Check All"}
                          isChecked={paymentOptions.isAllCheckedAdmins}
                          onChangeHandler={handleCheckAll}
                        />
                      }
                    >
                      <div className="flex flex-row w-full gap-14">
                        <CheckboxGroupComponent
                          purpose={"ADMINS_PAYMENT"}
                          options={paymentOptions.adminsPaymentOptions}
                          selectedOptions={paymentOptions.selectedOptionsAdmins}
                          onChangeHandler={handleCheckboxGroup}
                        />
                      </div>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-5 mr-3" gutter={16}>
                  <Col span={8}>
                    <Card
                      title="POS Banks"
                      extra={
                        <button className="flex items-center" onClick={() => {
                          setPosBankList(syncPosBankListWithSelectedBanks(posBankList, selectedPosBanks));
                          setOpenPosBankModal(true);
                        }}>
                          {selectedPosBanks.length > 0 ? (
                            <Image src="/images/icons/item_edit.svg" preview={false} height={24} width={24} />
                          ) : (
                            <Image src="/images/icons/add-icon-new.svg" preview={false} height={28} width={28} />
                          )}
                        </button>
                      }
                      variant="borderless"
                      // onClick={() => showNotification("Please, contact vendor to change inventory type")}
                    >
                      {selectedPosBanks.length > 0 && (
                        <div className="flex flex-row flex-wrap px-5 py-5 w-full gap-14">
                          <ConfigProvider
                            theme={{
                              token: {
                                colorPrimary: "#572D86",
                                colorPrimaryBorder: "#572D86",
                                colorPrimaryHover: "#572D86",
                                controlOutline: "#572D86",
                                colorBorder: "#572D86",
                              },
                            }}
                          >
                            <Checkbox.Group
                              style={{ transform: "scale(1.1)" }}
                              className="pos-bank-checkbox-group break-all"
                              options={[...preparePosBankCheckboxOptions(selectedPosBanks)]}
                              value={[...selectedPosBanks.map((el) => el.posBankId)]}
                              onChange={onHandlePosBankCheckbox}
                            />
                          </ConfigProvider>
                        </div>
                      )}
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      title="Takeout Types"
                      variant="borderless"
                      extra={
                        <CheckAllComponent
                          purpose={"TAKEOUT_TYPES"}
                          mainLabel=""
                          checkboxLabel={"Check All"}
                          isChecked={takeoutTypeSettings.isAllChecked}
                          onChangeHandler={handleCheckAll}
                        />
                      }
                    >
                      <div className="flex flex-row w-full gap-14">
                        <CheckboxGroupComponent
                          purpose={"TAKEOUT_TYPES"}
                          options={takeoutTypeSettings.takeoutTypes}
                          selectedOptions={takeoutTypeSettings.selectedTakeoutTypes}
                          onChangeHandler={handleCheckboxGroup}
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      title="Inventory Type"
                      variant="borderless"
                      onClick={() => showNotification("Please, contact vendor to change inventory type")}
                    >
                      <div className="flex flex-row w-full gap-14">
                        <Radio.Group
                          disabled
                          onChange={(e) => setInventoryType(e.target.value)}
                          value={inventoryType}
                          style={{ display: "flex", gap: 20 }}
                        >
                          <Radio value="ITEM">Item Wise</Radio>
                          <Radio value="INGREDIENT">Ingredients wise</Radio>
                        </Radio.Group>
                      </div>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-5 mr-3" gutter={16}>
                  <Col span={24}>
                    <Card
                      title={
                        <div className="flex justify-start items-center w-full">
                          <div className="w-5/12">Loyalty Program</div>

                          <div className="ml-10">
                            <RadioButtonGroupComponent
                              purpose="LOYALTY_PROGRAM"
                              selectedValue={loyaltySettings.isActive}
                              onChangeHandler={onChangeRadioButtonHandler}
                            />
                          </div>
                        </div>
                      }
                      variant="borderless"
                    >
                      <Row gutter={[16, 16]} className="flex flex-wrap">
                        <Col md={24} lg={12} className="flex">
                          <Card className="w-full flex-1">
                            {/* Content of first box */}
                            <div className="mb-4">
                              <CheckAllComponent
                                purpose={"LOYALTY_POINT_BASED"}
                                mainLabel=""
                                checkboxLabel={"Point Based"}
                                isChecked={loyaltySettings.pointBasedSystem.isActive}
                                onChangeHandler={handleCheckAll}
                              />
                            </div>
                            <div className="space-y-4 text-center 2xl:space-y-0 flex flex-col 2xl:flex-row 2xl:items-center 2xl:space-x-4">
                              {/* Text Field 1 */}
                              <div className="flex items-center gap-2">
                                <CustomInputNumber
                                  placeholder={"1"}
                                  min={0}
                                  max={99999}
                                  name={`1_pointPerHundredTKSpent`}
                                  value={loyaltySettings.pointBasedSystem.pointPerHundredTKSpent}
                                  setValue={updateLoyaltySettings}
                                  isDecimalAllowed={true}
                                  shouldSetValueSetObj={true}
                                />
                                <label className="xl:whitespace-nowrap mt-1 xl:mt-0 shrink-0">Points per 100 TK</label>
                              </div>

                              {/* Text Field 2 */}
                              <div className="flex items-center gap-2">
                                <label className="xl:whitespace-nowrap mt-1 xl:mt-0 shrink-0">Minimum</label>
                                <CustomInputNumber
                                  placeholder={"200"}
                                  min={0}
                                  max={99999}
                                  name={`2_minRedeemPoint`}
                                  value={loyaltySettings.pointBasedSystem.minRedeemPoint}
                                  setValue={updateLoyaltySettings}
                                  isDecimalAllowed={true}
                                  shouldSetValueSetObj={true}
                                />
                                <label className="xl:whitespace-nowrap mt-1 xl:mt-0 shrink-0">points to redeem</label>
                              </div>
                            </div>
                          </Card>
                        </Col>

                        <Col md={24} lg={12} className="flex">
                          <Card className="w-full flex-1">
                            {/* Content of second box */}
                            <div className="mb-4">
                              <CheckAllComponent
                                purpose={"LOYALTY_SPEND_BASED"}
                                mainLabel=""
                                checkboxLabel={"Spend Based"}
                                isChecked={loyaltySettings.spentBasedSystem.isActive}
                                onChangeHandler={handleCheckAll}
                              />
                            </div>
                            {loyaltySlabs.map((slab, idx) => (
                              <div className="w-full flex items-center gap-x-[15px] mb-2" key={idx}>
                                <LoyaltyProgramSpendBaseSlabs slab={slab} updateLoyaltySlabs={updateLoyaltySlabs} />

                                <button
                                  className={`mt-1 ${loyaltySlabs.length > 1 ? "" : "invisible"}`}
                                  onClick={() => onHandleAddRemoveLoyalSlabs(slab.uuid)}
                                >
                                  <Image src="/images/icons/remove_one.svg" preview={false} />
                                </button>
                                <button
                                  className={`mt-1 ${idx === loyaltySlabs.length - 1 ? "" : "invisible"}`}
                                  onClick={() => onHandleAddRemoveLoyalSlabs()}
                                >
                                  <Image src="/images/icons/add_one.svg" preview={false} />
                                </button>
                              </div>
                            ))}
                          </Card>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </div>
              <div className="text-center  ">
                <button
                  className="bg-yellow text-black w-[150px] m-2 p-3 rounded-[5px] font-ubold"
                  onClick={updateSettings}
                >
                  Update
                </button>
              </div>
            </Card>
          </div>
          {/** end of card */}

          <div className="flex flex-row m-[16px] text-xl gap-6">
            <div className="w-[180px] font-ubold">Openings:</div>
            <div className="flex flex-col">
              {["Sat", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri"].map((day) => {
                const isOpen = branch.openDays?.includes(day);
                return (
                  <div className="flex flex-row py-[4px]" key={day}>
                    <div
                      className={`text-sm px-[16px] mx-[8px] font-ubold w-[20px] ${
                        isOpen ? "text-green" : "text-red-500"
                      }`}
                    >
                      {day}
                    </div>
                    <div className={`text-sm px-[16px] mx-[8px] ${isOpen ? "text-preblack" : "text-red-500"}`}>
                      {isOpen ? `${branch.openTime} --- ${branch.closeTime}` : "Closed"}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <PosBanksModal
          open={openPosBankModal}
          setOpenModal={setOpenPosBankModal}
          banks={posBankList}
          updatePosBankList={updatePosBankList}
          handlePosBankDone={onHandlePosBankDoneBtn}
          handleCancelPosBank={onHandlePosBankCancelBtn}
        />
      </div>
    </div>
  );
}

export default Profile;
